import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { UserSegment } from 'src/app/models/UserSegment';
@Injectable({
    providedIn: 'root'
})
export class UserSegmentApi extends Api<UserSegment> {
}
